import { render } from "./customers-login.vue?vue&type=template&id=0211da6c"
import script from "./customers-login.vue?vue&type=script&lang=js"
export * from "./customers-login.vue?vue&type=script&lang=js"

import "./customers-login.vue?vue&type=style&index=0&id=0211da6c&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__